import React, {
} from "react";
import logo from "../../assets/rejoni/rejoni.png"
import medicalimg1 from "../../assets/rejoni/medicalimg1.png"
import medicalimg2 from "../../assets/rejoni/medicalimg2.png"
import { Grid, TextField, Button, 

  Box, Typography,

    useMediaQuery} from "@mui/material";
import "./rejoni.scss"
import { MediaPlayer, MediaProvider, Poster } from "@vidstack/react";
import {  defaultLayoutIcons,  DefaultVideoLayout} from "@vidstack/react/player/layouts/default";
import "react-image-gallery/styles/css/image-gallery.css";
import "@vidstack/react/player/styles/default/theme.css";
import "@vidstack/react/player/styles/default/layouts/video.css";
import '@vidstack/react/player/styles/default/layouts/audio.css';



const headerStyle = {
  backgroundColor: "white",
  padding: "1rem 0",
  display: "block",
  justifyContent: "center",
  alignItems: "center",
  margin:'auto',
  textAlign:'center'
};

const logoImageStyle: React.CSSProperties = {
  height: "50px",
  objectFit: "contain" as "contain" | "cover" | "fill" | "none" | "scale-down", // Explicitly typing objectFit
};

const gridContainerStyle: React.CSSProperties = {
    background:"#CCCFCB",
    width:'100%',
    gap: "1rem", 
    padding: "1rem",
    alignItems:"center",
    justifyContent:"center",
    justifyItems:"center"
  };
  
 
  const font = 'Righteous, serif,  system-ui';
  const font1 = 'Josefin Sans, Arial, sans-serif';
  const footerStyle = {
    color: "white",
    padding: "20px 0",
    textAlign: "center",
    width: "100%", // Ensure the footer spans the full width
    position: "relative", // Can also use fixed or sticky if needed
    left: 0, 
  };



    const RejoniPresentation = () => {
    const isMobile = useMediaQuery("(max-width:720px)");
        return (
          <div>
            <Box>
              <Grid container>
                {/* Header Section */}
                <Grid item sm={12} md={12}>
                  <Box sx={headerStyle}>
                    <img
                      src={logo}
                      alt="Logo"
                      style={{...logoImageStyle, paddingLeft: isMobile ? '15px' : ''}}
                    />
                  </Box>
                </Grid>
              </Grid>
              <Grid container>
                {/* Banner Section */}
                <Grid item sm={12} md={12}>
                  <Box sx={gridContainerStyle}>
                    <Box
                      sx={{
                        padding: '72px 0',
                        width: '100%',
                        margin: 'auto',
                        backgroundColor: '#CCCFCB',
                        textAlign: 'center',
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: `${font}!important`,
                          textTransform: 'uppercase',
                          fontSize: isMobile ? '20px' :'32px',
                          margin: '0px auto',
                          letterSpacing: 4,
                          wordSpacing: 2,
                          width: isMobile ? '90%': '80%',
                        }}
                      >
                        Have you been told that you have intrauterine{isMobile ? '' : <br />}  Adhesions or Fibroids?
                      </Typography>
                      <Typography
                        sx={{
                          fontFamily: `${font1}!important`,
                          textAlign: 'center',
                          letterSpacing: 1,
                          wordSpacing: 4,
                          fontSize: isMobile ? '20px' :'24px',
                          mt: 2,
                        }}
                      >
                        Learn about a clinical trial that is evaluating a new product
                        <br />
                        which may prevent them.
                      </Typography>
                      <Button
                        sx={{
                          backgroundColor: '#000000',
                          fontSize: '15px',
                          color: '#ffffff',
                          height:  isMobile ? '40px' : '50px',
                          width:  isMobile ? '150px' : '170px',
                          fontFamily: `${font1}!important`,
                          letterSpacing: 2,
                          mt: 3,
                          '&:hover': {
                            backgroundColor: '#333333', // Optionally add hover effect
                          },
                        }}
                      >
                        LEARN MORE
                      </Button>
                    </Box>
                    <Box
                      sx={{
                        padding: '10px 0',
                        margin: 'auto',
                        backgroundColor: '#CCCFCB',
                        textAlign: 'center',
                      }}
                    >
                      <section
                        style={{
                          padding: '10px 0',
                          background: '#CCCFCB',
                          width:  isMobile ? '100%' : '60%',
                          margin:'0 auto'
                        }}
                      >
                        <MediaPlayer
                          key={1}
                          id="videoslider1"
                          className="carouselvideo"
                          src="https://clinicalvisuals.s3.amazonaws.com/medical/rejoni/Uterus/hls.m3u8"
                          viewType="video"
                          streamType="on-demand"
                          logLevel="warn"
                          crossOrigin
                          playsInline
                          title="clinicalvisuals"
                          poster="https://clinicalvisuals.s3.amazonaws.com/medical/rejoni/images/uterus_1000_800.png"
                          onError={(e) => console.error('Video Playback Error:', e)}
                        >
                          <MediaProvider>
                            <Poster className="vds-poster" />
                          </MediaProvider>
                          <DefaultVideoLayout icons={defaultLayoutIcons} />
                        </MediaPlayer>
                      </section>

                      <Box 
                        sx={{
                         
                          padding: '10px 0',
                          margin: 'auto',
                          backgroundColor: '#CCCFCB',
                          textAlign: 'center',
                        }}
                      >
                        <Typography mt={isMobile ? 2 : 8} mb={isMobile ? 2 : 4}
                          sx={{
                            fontFamily: `${font}!important`,
                            fontSize:  isMobile ? '20px' : '32px',
                            textTransform: 'uppercase',
                            letterSpacing: 4,
                            wordSpacing: 4,
                          }}
                        >
                          LEARN MORE OR SIGN UP FOR THE JUVEENA™ CLINICAL STUDY
                        </Typography>
                        <Button
                          sx={{
                            backgroundColor: '#000000',
                            fontSize: '15px',
                            color: '#ffffff',
                            height:  isMobile ? '70px' : '50px',
                            paddingLeft: 2,
                            paddingRight: 2,
                            fontFamily: `${font1}!important`,
                            letterSpacing: 2,
                            mt: 2,
                            '&:hover': {
                              backgroundColor: '#333333',
                            },
                          }}
                        >
                          CLICK HERE FOR MORE INFORMATION
                        </Button>
                      </Box>
                    </Box>
                  </Box>
                </Grid>
                <Grid item sm={12} md={12}>
                  <Box> 
                    <Typography
                      sx={{
                        paddingTop: isMobile ? '40px' : '50px',
                        paddingBottom: isMobile ? '20px' : '10px',
                        textAlign:'center',
                        fontFamily: `${font}!important`,
                        fontSize:  isMobile ? '20px' : '40px',
                        textTransform: 'uppercase',
                        color: '#8F968c',
                        marginTop: 0,
                        letterSpacing:'5px',
                        fontWeight:'500'
                      }}
                    >
                      What are Intrauterine Adhesions?
                    </Typography>
                    <Box
                      sx={{
                        margin: 'auto',
                        padding: 2,
                        marginTop: isMobile ? '15px' : '25px',
                        width:  isMobile ? '100%x' : '70%',
                        justifyContent: 'center',
                        alignItems: 'center',
                        justifyItems: 'center',
                        height: 'auto',
                      }}
                    >
                      <img
                        src={medicalimg2}
                        alt="Medical Image"
                        style={{ width: '100%',
                           borderRadius: '15px'
                         }}
                      />
                    </Box>
                    <Typography
                      sx={{
                        fontFamily: `${font1}!important`,
                        fontSize: isMobile ? '18px' : '24px',
                        width:  isMobile ? '90%' : '69%',
                        textAlign: 'center',
                        color: '#5e5e5e',
                        margin: '0 auto',
                        marginTop: '20px',
                        marginBottom: isMobile ? '30px' :  '80px',
                        lineHeight: '1.5',
                      }}
                    >
                      Commonly referred to as “Asherman's Syndrome”, IUAs are bands of fibrous tissue that form in the uterus, often in response to a
                      uterine procedure. As many as 40% of women who have had some type of surgical procedure inside the uterus develop Asherman's
                      Syndrome. Your doctor can see these adhesions using ultrasound or by putting a thin telescope inside the uterus; a procedure
                      called hysteroscopy.
                    </Typography>

                    <Box
                      sx={{
                        margin: 'auto',
                        padding: 2,
                        width:  isMobile ? '100%' :  '70%',
                        justifyContent: 'center',
                        alignItems: 'center',
                        justifyItems: 'center',
                        height: 'auto',
                      }}
                    >
                      <img
                        src={medicalimg1}
                        alt="Medical Image"
                        style={{ width: '100%',
                           borderRadius: '15px'
                          }}
                      />
                    </Box>
                    <Typography
                      sx={{
                        fontFamily: `${font1}!important`,
                        width: isMobile ? '80%' :  '70%',
                        marginLeft: '20%',
                        textAlign: 'center',
                        color: '#5e5e5e',
                        margin: '0 auto',
                        marginTop: '20px',
                        marginBottom: '0',
                        lineHeight: 1.5,
                        paddingBottom:'30px',
                        fontSize: isMobile ? '18px' : '24px',
                      }}
                    >
                      The thicker the bands of scar tissue, the more they can cause the uterine cavity to narrow, resulting in pain, skipped, sparse or absent menstrual periods as well as recurring pregnancy loss and other pregnancy complications.
                    </Typography>
                  </Box>
                </Grid>
                <Grid item sm={12} md={12} sx={gridContainerStyle}>
                  <Box sx={{ padding: '50px 0' }}>
                    <Typography
                      sx={{
                        fontFamily: `${font}!important`,
                        fontWeight:'500',
                        fontSize: isMobile ? '25px' :  '40px',
                        letterSpacing: 4,
                        wordSpacing: 3,
                        textAlign: 'center',
                      }}
                    >
                      ABOUT REJONI'S CLINICAL STUDY
                    </Typography>
                    <Box sx={{ fontFamily: `${font1}!important`, textAlign: 'center', width: isMobile ? '100%' : '80%', margin: '0 auto'}}>
                      <Typography
                        sx={{
                          fontSize: isMobile ? '25px' :  '36px',
                          fontFamily: `${font1}!important`,
                          textAlign: 'center',
                          marginBottom: '20px',
                          marginTop: '40px',
                        }}
                      >
                        What is this clinical study about?
                      </Typography>
                      <Typography
                        sx={{
                          width: isMobile ? '100%' : '90%',
                          textAlign:'center',
                          margin:'0 auto',
                          fontSize: isMobile ? '20px' : '24px',
                          fontFamily: `${font1}!important`,
                        }}
                      >
                        Working closely with leading physicians, Rejoni™ is conducting a clinical trial to learn if a soft gel-like material,
                        called Juveena™ Hydrogel may prevent intrauterine adhesions after uterine surgery.
                      </Typography>

                      <Grid container mt={5} sx={{ width: '100%', display: 'flex' }}>
                        <Grid item sm={12} md={6} padding={isMobile ? 0 : 5} sx={{ width: '100%' }}>
                          <Typography
                            sx={{
                              textAlign: 'center',
                              fontFamily: `${font1}!important`,
                              fontSize:  isMobile ? '25px' : '36px',
                              paddingBottom:'20px',
                               wordSpacing:'4px'
                            }}
                          >
                            How does the clinical study work?
                          </Typography>
                          <Typography
                            sx={{
                              width: isMobile ? '100%' : '100%',
                              fontSize: isMobile ? '21px' : '24px',
                              fontFamily: `${font1}!important`,

                            }}
                          >
                            In this study, potential participants are those who are undergoing uterine surgery either to remove fibroids or
                            to disrupt existing adhesions in a procedure called adhesiolysis. Qualified participants will be randomly assigned to
                            either receive instillation of the hydrogel (treatment group) directly after completion of the uterine surgery or to
                            not have the hydrogel instilled (control group). Two women will be assigned to the treatment group for every one assigned to the control group.
                          </Typography>
                        </Grid>

                        <Grid item  sm={12} md={6}   padding={isMobile ? 0 : 5} >
                          <Typography
                            sx={{
                              textAlign: 'center',
                              fontFamily: `${font1}!important`,
                              fontSize:  isMobile ? '25px' :  '36px',
                              paddingBottom:'20px',
                              paddingTop: isMobile ? '30px' : '0px',
                              wordSpacing:'4px'

                            }}
                          >
                            Am I eligible for this clinical study?
                          </Typography>
                          <Typography
                            sx={{
                              width: isMobile ? '100%' : '100%',
                              fontSize: isMobile ? '21px' : '24px',
                              fontFamily: `${font1}!important`,
                              wordSpacing:'4px'

                            }}
                          >
                            <b>If you are at least 18 years old</b>, and your diagnosis through imaging has identified that you should undergo fibroid
                            removal or adhesiolysis, you may be eligible to participate. There is no cost to you to participate in this clinical study.
                          </Typography>
                        </Grid>
                      </Grid>
                    </Box>
                  </Box>
                </Grid>
                <Grid item sm={12} md={12} >
                  <Box pt={4} pb={4} sx={{ textAlign: 'center', marginBottom: '4%' }}>
                    <Typography
                        variant="h4"
                        sx={{
                          fontSize: isMobile ? '25px' : '40px',
                          color: '#8F968c',
                          fontFamily: `${font}!important`,
                          textTransform: 'uppercase',
                          letterSpacing: 4,
                          wordSpacing: 5,
                          paddingBottom:'30px',
                          fontWeight:'500',
                          textAlign:'center'
                        }}
                      >
                        Study Locations
                      </Typography>

                      <Box
                        sx={{
                          display: 'block',
                          justifyContent: 'center',
                          alignItems: 'center',
                          width: '100%',
                          height: '90%',
                          marginLeft: isMobile ? '20px' : '',
                        }}
                      >
                        <iframe
                          src="https://www.google.com/maps/d/embed?mid=1kxalmUVRMSTNPqQ0__ZEyMU8r4MbdrQ&ehbc=2E312F"
                          width= {isMobile ? '90%' : '60%'}
                          height={isMobile ? '400px' : '600px'}
                          style={{ border: 'none' }}
                        ></iframe>
                      </Box>
                  </Box>
                </Grid>
                <Grid item sm={12} md={12} sx={gridContainerStyle}>
                <Typography
                      variant="h4"
                      sx={{
                        fontSize:isMobile ? '25px' : '40px',
                        fontFamily: `${font}!important`,
                        textTransform: 'uppercase',
                        letterSpacing: 6,
                        wordSpacing: 5,
                        textAlign: 'center',
                        marginBottom: '16px',
                      }}
                    >
                      Interested in Participating in Our Study?
                    </Typography>
                  <Box sx={{ width:isMobile ? '100%' : '50%', margin: '0 auto', padding: '20px', backgroundColor: '#CCCFCB', borderRadius: '8px' }}>
                    

                    <Typography
                      sx={{
                        fontFamily: `${font1}!important`,
                        letterSpacing: 1,
                        fontSize: isMobile ? '20px' : '24px',
                        textAlign: 'center',
                        marginBottom: '20px',
                      }}
                    >
                      Please fill out this form to get in touch with a clinical study coordinator.
                    </Typography>

                    <form>
                      <Grid container spacing={3}>
                        {/* Name */}
                        <Grid item xs={12}>
                          <TextField
                            label="Name"
                            variant="filled"
                            type="text"
                            fullWidth
                            required
                            size="small"
                            sx={{
                              '& .MuiFilledInput-root': {
                                backgroundColor: '#BEc1BE',
                                fontFamily: "'Josefin Sans', sans-serif !important" ,
                              },
                              '& .MuiInputLabel-root': {
                                color: 'black',
                                fontFamily: "'Josefin Sans', sans-serif !important",
                              },
                              '& .MuiInputLabel-root.Mui-focused': {
                                color: 'black',
                              },
                            }}
                          />
                        </Grid>

                        {/* Email */}
                        <Grid item xs={12}>
                          <TextField
                            label="Email"
                            variant="filled"
                            type="email"
                            fullWidth
                            required
                            size="small"
                            sx={{
                              '& .MuiFilledInput-root': {
                                backgroundColor: '#BEc1BE',
                                fontFamily: "'Josefin Sans', sans-serif !important",
                              },
                              '& .MuiInputLabel-root': {
                                color: 'black',
                                fontFamily: "'Josefin Sans', sans-serif !important",
                              },
                              '& .MuiInputLabel-root.Mui-focused': {
                                color: 'black',
                              },
                            }}
                          />
                        </Grid>

                        {/* Phone Number */}
                        <Grid item xs={12}>
                          <TextField
                            label="Phone Number"
                            variant="filled"
                            type="text"
                            fullWidth
                            required
                            size="small"
                            sx={{
                              '& .MuiFilledInput-root': {
                                backgroundColor: '#BEc1BE',
                                fontFamily: "'Josefin Sans', sans-serif !important",
                              },
                              '& .MuiInputLabel-root': {
                                color: 'black',
                                fontFamily: "'Josefin Sans', sans-serif !important" ,
                              },
                              '& .MuiInputLabel-root.Mui-focused': {
                                color: 'black',
                              },
                            }}
                          />
                        </Grid>

                        {/* Zip Code */}
                        <Grid item xs={12}>
                          <TextField
                            label="Zip Code"
                            variant="filled"
                            type="text"
                            fullWidth
                            required
                            size="small"
                            sx={{
                              '& .MuiFilledInput-root': {
                                backgroundColor: '#BEc1BE',
                                fontFamily: "'Josefin Sans', sans-serif !important",
                              },
                              '& .MuiInputLabel-root': {
                                color: 'black',
                                fontFamily: "'Josefin Sans', sans-serif !important",
                              },
                              '& .MuiInputLabel-root.Mui-focused': {
                                color: 'black',
                              },
                            }}
                          />
                        </Grid>

                        {/* Preferred Clinical Study Site */}
                        <Grid item xs={12}>
                          <TextField
                            label="Preferred Clinical Study Site (see map above)"
                            variant="filled"
                            type="text"
                            fullWidth
                            required
                            size="small"
                            sx={{
                              '& .MuiFilledInput-root': {
                                backgroundColor: '#BEc1BE',
                                fontFamily: "'Josefin Sans', sans-serif !important",
                              },
                              '& .MuiInputLabel-root': {
                                color: 'black',
                                fontFamily: "'Josefin Sans', sans-serif !important",
                              },
                              '& .MuiInputLabel-root.Mui-focused': {
                                color: 'black',
                              },
                            }}
                          />
                        </Grid>

                        {/* Other Notes */}
                        <Grid item xs={12}>
                          <TextField
                            label="Other Notes"
                            variant="filled"
                            type="text"
                            fullWidth
                            required
                            size="small"
                            multiline
                            rows={4}
                            sx={{
                              '& .MuiFilledInput-root': {
                                backgroundColor: '#BEc1BE',
                                fontFamily: "'Josefin Sans', sans-serif !important",
                              },
                              '& .MuiInputLabel-root': {
                                color: 'black',
                                fontFamily: "'Josefin Sans', sans-serif !important",
                              },
                              '& .MuiInputLabel-root.Mui-focused': {
                                color: 'black',
                              },
                            }}
                          />
                        </Grid>

                        {/* Submit Button */}
                        <Grid item xs={12} container justifyContent="center" alignItems="center">
                          <Button
                            variant="contained"
                            color="primary"
                            sx={{
                              backgroundColor: '#000000',
                              fontSize: '15px',
                              color: '#ffffff',
                              height: '50px',
                              padding: isMobile ? 2 : 4,
                              textTransform: 'uppercase',
                              fontFamily: `${font1}!important`,
                            }}
                          >
                            Send
                          </Button>
                        </Grid>
                      </Grid>
                    </form>

                    {/* reCAPTCHA Disclaimer */}
                    <Typography
                      sx={{
                        fontFamily: `${font1}!important`,
                        letterSpacing: 1,
                        fontSize: '12px',
                        textAlign: 'center',
                        marginTop: '16px',
                      }}
                    >
                      This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
              <Grid container  sx={{ width: "100%", padding:'30px 0px', backgroundColor: "#161616" }}>
                <Grid item sm={12} md={12} >
                  <Grid container >
                    <Grid item sm={12} md={8}>
                      <Box>
                        <Box sx={{ ...footerStyle, textAlign: isMobile ? "center" : "left",  }}>
                          <Typography 
                              variant="body2" 
                              sx={{ fontFamily: "'Josefin Sans', sans-serif !important", marginTop: "20px", marginLeft: isMobile ? '' :  "20%", fontSize: isMobile ? '18px' : '19px', color:'#a4a4a4', width:isMobile ? '90%' : '50%', margin:isMobile ? '0 auto' :'' }}>
                              Copyright © 2023 <strong>Rejoni</strong>. All Rights Reserved.
                          </Typography>

                          <Typography 
                              variant="body2" 
                              sx={{ fontFamily: "'Josefin Sans', sans-serif !important", paddingTop: '15px', width: isMobile ? '90%' :   "50%", marginTop: "20px", marginLeft: isMobile ? '' :   "20%", color:'#a4a4a4', margin:isMobile ? '0 auto' :'', fontSize: isMobile ? '16x' : '19px'  }}>
                              These statements have not been evaluated by the Food and Drug Administration. {isMobile ? <br/> : '' } 
                              CAUTION – Investigational device. Limited by Federal (USA) Law to investigational use.
                          </Typography>
                        </Box>
                      </Box>
                    </Grid>
                    <Grid item sm={12} md={4} sx={{    width: '100%'}}>
                      <Box sx={footerStyle}>
                        <Box sx={{justifyContent:'center', textAlign:'center', width:'100%'}}  >
                          <Typography 
                            variant="body2" 
                            sx={{ fontFamily: "'Josefin Sans', sans-serif !important", paddingTop: '15px', color:'#a4a4a4', margin:isMobile ? '0 auto' :'', fontSize: isMobile ? '16x' : '16px' }}>
                            REJ-MKT-0005 Rev. C
                          </Typography>
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>


            </div>
    );
    };

export default RejoniPresentation;
